<ng-container header>
    <div class="filters-container">
        <div class="search-wrapper"></div>
        <div class="button-filters-wrapper">
            <due-date-filter-drop-down
                translationKeyFilterName="cpmm_projects_overview_col_balance_sheet_date"
                [selectedYears]="projectsFilter?.years || []"
                (filterChange)="onDueDateFilterChange($event)"
            ></due-date-filter-drop-down>

            <user-filter-drop-down
                label="aumico_projects_overview_filter_assignee_label"
                [users]="searchedAssigneeOptions"
                [selectedUserIds]="projectsFilter?.assignee || []"
                [currentUserId]="activeUserAumicoInternalId"
                [view]="'projects'"
                (userChange)="onAssigneeFilterChange($event)"
                (searchChange)="onSearchFilterChangeAssignee($event)"
            ></user-filter-drop-down>
            <report-type-filter-drop-down
                *ngIf="isCpmmActive"
                [selectedReportType]="projectsFilter && projectsFilter.reportTypeIds ? projectsFilter.reportTypeIds : []"
                (statusChange)="onReportTypeFilterChange($event)"
            ></report-type-filter-drop-down>

            <status-filter-drop-down
                [statusOptions]="statusOptions"
                [selectedStatus]="projectsFilter && projectsFilter.projectStatus ? projectsFilter.projectStatus : []"
                (statusChange)="onProjectStatusFilterChange($event)"
            ></status-filter-drop-down>

            <ham-button
                *ngIf="selectedCompanyDto?.active"
                class="create-project-button"
                (buttonClick)="openCreateProjectDialog()"
                variant="primary"
                icon="assets/hamIcons/plus-outline.svg"
                size="lg"
                >{{ 'aumico_projects_overview_add_new_project' | i18next }}</ham-button
            >
        </div>
    </div>
</ng-container>
<ng-container content>
    <div class="projects-overview-container">
        <aumico-project-overview-table
            [anyActiveFilter]="isAnyFilterActive()"
            [projects]="projectsOverviewTableData"
            [activeNav]="activeNavigation"
            [abcpClosing]="abcpClosing"
            [disableNewProjectButtonEmptyState]="!selectedCompanyDto?.active"
            [activeSortBy]="projectsFilter?.sortBy || null"
            [activeSortOrder]="projectsFilter?.sortOrder || null"
            (sortProjects)="sortProjects($event)"
            (updateProjectStatus)="onUpdateProjectStatus($event)"
            (deleteProject)="onDeleteProject($event)"
            (selectProject)="onSelectProject($event)"
            (onScrollEndReached)="loadMoreProjects()"
            (addNewProject)="openCreateProjectDialog()"
            [allProjectsSelected]="allProjectsSelected"
            [selectedProjects]="selectedProjects"
            (toggleCheckAllProject)="onToggleCheckAllProject()"
            (toggleCheckProject)="onToggleCheckProject($event)"
        >
        </aumico-project-overview-table>
    </div>
</ng-container>

<ham-modal
    *ngIf="showCreateProjectPopup"
    class="feedback"
    [hideFooter]="true"
    [showCancelButton]="'false'"
    hideHeader="true"
>
    <new-project-wizard
        [companiesList]="companiesList"
        [company]="company"
        [cpmmIsActive]="isCpmmActive"
        [balanceSheetDate]="balanceSheetDate"
        (selectedCompany)="onCompanySelected($event)"
        (selectedBalanceSheetDate)="onBalanceSheetDateSelected($event)"
        (selectedReportType)="onReportTypeSelected($event)"
        (selectedMandateManagementWorkflow)="onMandateManagementWorkflowSelected($event)"
        (selectedClosingWorkflow)="onClosingWorkflowSelected($event)"
        (closeButtonClicked)="closeNewProjectDialog($event)"
    ></new-project-wizard>
</ham-modal>
<app-loading-spinner [active]="isCreatingAnnualReport"></app-loading-spinner>

<!-- Bulk Edit action bar -->
<bulk-edit-action-bar
    *ngIf="selectedProjects?.size > 0"
    [selectedCount]="selectedProjects?.size"
    [actions]="bulkActions"
    [deleteAction]="deleteAction"
    textSelectedTranslationKey="aumico_companies_bulk_edit_action_bar_selected_text"
    [globalPosition]="true"
    (actionClicked)="onActionClicked($event)"
></bulk-edit-action-bar>

<!-- Ham Modal for Bulk Edit Status -->
<ham-modal
    *ngIf="openBulkEditStatus"
    [title]="'aumico_project_overview_bulk_update_status' | i18next : { count: selectedProjects.size }"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    (cancel)="openBulkEditStatus = false"
    [saveText]="'aumico_button_save' | i18next"
    (save)="editStatusSelected()"
    ><input
        hamSimpleDropDown
        [label]="'aumico_project_overview_bulk_update_status_label' | i18next"
        [options]="possibleStatus"
        [optionKeys]="['name']"
        returnKey="id"
        [returnObject]="true"
        [placeholder]="'aumico_project_overview_bulk_update_status_placeholder' | i18next"
        [formControl]="bulkEditStatusControl"
/></ham-modal>

<ham-confirm-decline-modal
    *ngIf="openAutoTaskUpdateDialog"
    (cancel)="onEditStatusConfirm(false)"
    (action)="onEditStatusConfirm(true)"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_projects_overview_status_update_modal_confirm' | i18next }}"
    noActionBtnText="{{ 'aumico_projects_overview_status_update_modal_cancel' | i18next }}"
    btnVariant="primary"
>
    <div class="ham-icon">
        <i class="check-circle-outline"></i>
    </div>
    <p class="project-update-modal-text">{{ 'aumico_projects_overview_status_update_modal_text' | i18next }}</p>
</ham-confirm-decline-modal>

<!-- HamModal for Bulk Delete -->
<ham-confirm-decline-modal
    *ngIf="openBulkDeleteConfirmationDialog"
    (cancel)="cancelDeleteBulkProjects()"
    (action)="confirmDeleteBulkProjects()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_button_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_button_cancel' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_app_cpmm_projects_delete_confirmation' | i18next : { count: selectedProjects.size }"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>

<!-- Asks whether to delete projects that other reports build on. -->
<ham-confirm-decline-modal
    *ngIf="openBulkDeleteDependencyWarningDialog"
    (cancel)="skipDeleteWithDependencies()"
    (action)="confirmDeleteWithDependencies()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_bulk_delete_dependency_warning_proceed' | i18next }}"
    noActionBtnText="{{ 'aumico_bulk_delete_dependency_warning_skip' | i18next }}"
>
    <div class="dependency-warning-body">
        <p>{{ 'aumico_bulk_delete_dependency_warning_description' | i18next }}</p>
        <ul>
            <li *ngFor="let warning of pendingDependencyWarnings">
                <strong>{{ getProjectNameById(warning.projectId) }}</strong>:
                {{ warning.dependentReports?.join(', ') ?? '' }}
            </li>
        </ul>
    </div>
</ham-confirm-decline-modal>
